import { ReplaySubject } from "rxjs";

function OptionsStream() {
  this.playbackMode = (mode) => {
    this.stream.next({ loopMode: mode });
  };

  this.cardFormat = (format) => {
    this.stream.next({ cardFormat: format });
  };

  this.lyricsActive = (flag) => {
    this.stream.next({ lyricsActive: flag });
  };

  this.stream = new ReplaySubject(1);
}

export const options$ = new OptionsStream();
